import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { Country as CountryType } from '@ps/web-shared-components';

import countries from '@swf/generated/countries.json';

const esRecognisedCountries = countries.filter(
  (country: { value: string }) => !['TP', 'YU', 'AN'].includes(country.value)
);

const ukCountries = countries.filter((country: { value: string }) =>
  ['GB', 'JE', 'GI', 'GG'].includes(country.value)
);

export const getCountries = (site: Sites, country?: string): CountryType[] =>
  site === Sites.SPA
    ? esRecognisedCountries
    : ukCountries.find((ukCountry: { value: string }) => ukCountry.value === country)
    ? ukCountries
    : countries;
